var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCpHardwareLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "550px",
    height: "721.9px",
    viewBox: "0 0 550 721.9",
    enableBackground: "new 0 0 550 721.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    d: "M414,494.8c0,0,5.2,7.3,13.2,7.3s13.2-6.8,13.2-6.8s3.5-2.9,8.1-0.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 146.6,
    y: 88.9,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 3,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.7,
    y: 112,
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    width: 234,
    height: 342.8
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.2,
    y: 11.1,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.7918,
    width: 477.1,
    height: 12.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.3,
    y: 8.7,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.5,
    width: 24,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.7,
    y: 8.7,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.5,
    width: 24,
    height: 17
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M166.1,697.5c0,0-7.7,8.2-15.6,8.3 c-7.9,0.1-14.6-7.3-14.6-7.3V28.9c0,0,4.9,0,15.1,0s15.1,0,15.1,0V697.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M135.9,698.5c-6.8-2.7-10.4,1-10.4,1 s-4.5,6.3-10.9,6.3c-8,0-13.2-7.3-13.2-7.3V28.9h34.5V698.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M101.4,698.5c-6.8-2.7-10.4,1-10.4,1 s-4.5,6.3-10.9,6.3c-8,0-13.2-7.3-13.2-7.3V28.9h34.5V698.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M407.3,697.5c0,0,7.7,8.2,15.6,8.3 c7.9,0.1,14.6-7.3,14.6-7.3V28.9c0,0-4.9,0-15.1,0c-10.2,0-15.1,0-15.1,0V697.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M437.5,698.5c6.8-2.7,10.4,1,10.4,1 s4.5,6.3,10.9,6.3c8,0,13.2-7.3,13.2-7.3V28.9h-34.5V698.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M472,698.5c6.8-2.7,10.4,1,10.4,1 s4.5,6.3,10.9,6.3c8,0,13.2-7.3,13.2-7.3V28.9H472V698.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M196,697.5c0,0-7.7,8.2-15.6,8.3 c-7.9,0.1-14.6-7.3-14.6-7.3V28.9c0,0,4.9,0,15.1,0s15.1,0,15.1,0V697.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M226.2,697.5c0,0-7.7,8.2-15.6,8.3 c-7.9,0.1-14.6-7.3-14.6-7.3V28.9c0,0,4.9,0,15.1,0c10.2,0,15.1,0,15.1,0V697.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M256.4,697.5c0,0-7.7,8.2-15.6,8.3 c-7.9,0.1-14.6-7.3-14.6-7.3V28.9c0,0,4.9,0,15.1,0s15.1,0,15.1,0V697.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M286.6,697.5c0,0-7.7,8.2-15.6,8.3 c-7.9,0.1-14.6-7.3-14.6-7.3V28.9c0,0,4.9,0,15.1,0s15.1,0,15.1,0V697.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M316.7,697.5c0,0-7.7,8.2-15.6,8.3 c-7.9,0.1-14.6-7.3-14.6-7.3V28.9c0,0,4.9,0,15.1,0c10.2,0,15.1,0,15.1,0V697.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M346.9,697.5c0,0-7.7,8.2-15.6,8.3 c-7.9,0.1-14.6-7.3-14.6-7.3V28.9c0,0,4.9,0,15.1,0c10.2,0,15.1,0,15.1,0V697.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M377.1,697.5c0,0-7.7,8.2-15.6,8.3 c-7.9,0.1-14.6-7.3-14.6-7.3V28.9c0,0,4.9,0,15.1,0c10.2,0,15.1,0,15.1,0V697.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DADADA",
    stroke: "#706F6F",
    strokeWidth: 0.9525,
    strokeMiterlimit: 10,
    d: "M407.3,697.5c0,0-7.7,8.2-15.6,8.3 c-7.9,0.1-14.6-7.3-14.6-7.3V28.9c0,0,4.9,0,15.1,0c10.2,0,15.1,0,15.1,0V697.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeWidth: 4.2976,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    x1: 49.4,
    y1: 28.9,
    x2: 49.4,
    y2: 329.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeMiterlimit: 10,
    d: "M49.4,364.6L49.4,364.6c-2.6,0-4.6-2.1-4.6-4.6v-25.5 c0-2.6,2.1-4.6,4.6-4.6h0c2.6,0,4.6,2.1,4.6,4.6V360C54,362.5,51.9,364.6,49.4,364.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpHardwareLeft);
export default __webpack_public_path__ + "static/media/cp_hardware_left.f1a22c540edcc55c9d2d29d7eb286a4e.svg";
export { ForwardRef as ReactComponent };